"use client";
import React from "react";
import styles from "./AgentNotService.module.scss";
import SvgAgentNotService from "@/app/icons/SvgAgentNotService.svg";
import ChatHeader from "../chatHeader";

export default function AgentNotService({ content }: { content: string }) {
  if (!content) {
    return <ChatHeader />;
  }
  return (
    <div className={styles.agentBox}>
      <div className={styles.header}>
        <ChatHeader />
      </div>
      <div className={styles.content}>
        <SvgAgentNotService />
        <span dangerouslySetInnerHTML={{ __html: content }}></span>
      </div>
    </div>
  );
}
